export const formatCpf = (value: string) => {
  const digits = value?.replace(/\D/g, '') ?? ''

  if (digits.length !== 11) {
    return value ?? ''
  }

  return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
}
